import React from 'react';

const Logo = ({ variant = 'dark' }) => {
  const textColor = variant === 'dark' ? 'text-[#1a0d33]' : 'text-white';
  const subColor = variant === 'dark' ? 'text-[#5F259F]' : 'text-purple-200';
  return (
    <a href="#home" className="flex items-center gap-2.5 select-none group">
      <div className="relative w-11 h-11 rounded-2xl gradient-primary flex items-center justify-center soft-shadow group-hover:scale-105 transition-transform">
        <svg viewBox="0 0 24 24" className="w-6 h-6 text-white" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M2 20 L8 10 L12 14 L16 6 L22 20 Z" fill="white" fillOpacity="0.15" />
          <path d="M2 20 L8 10 L12 14 L16 6 L22 20 Z" />
          <circle cx="16" cy="6" r="1" fill="white" />
        </svg>
      </div>
      <div className="leading-tight">
        <div className={`font-extrabold text-xl tracking-tight ${textColor}`}>
          Himalayan<span className="text-[#5F259F]">POS</span>
        </div>
        <div className={`text-[10px] font-medium tracking-wide ${subColor}`}>
          SMART PAYMENTS · STRONGER BUSINESS
        </div>
      </div>
    </a>
  );
};

export default Logo;
